import { render, staticRenderFns } from "./ClientStatusCard.vue?vue&type=template&id=23eeab24&lang=pug"
import script from "./ClientStatusCard.vue?vue&type=script&lang=js"
export * from "./ClientStatusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports